module.exports = __webpack_public_path__ + "img/logo_light_2.0e278e42.png";